/** Atajos globales del CRM (PrivateLayout). */

export const CRM_SHORTCUTS_PANEL_TOGGLE_KEY = '?';

export const CRM_NAV_SHORTCUTS = [
  {
    id: 'derivacion',
    keys: ['F7'],
    label: 'Gestión Derivación',
    description: 'Cola y seguimiento de derivaciones',
    path: '/gestion-derivacion',
    icon: '📋',
    permission: 'ver_gestion_derivacion',
    allowAdmin: false
  },
  {
    id: 'pedidos-recetas-medico',
    keys: ['F8'],
    label: 'Pedidos / Recetas',
    description: 'Revisión médica de pedidos y recetas',
    path: '/pedidos-recetas-medico',
    icon: '🩺',
    permission: 'ver_pedido_recetas_medico',
    allowAdmin: false
  },
  {
    id: 'recetas-emitir',
    keys: ['F9'],
    label: 'Recetas a emitir',
    description: 'Cola de recetas pendientes de emisión',
    path: '/recetas-emitir',
    icon: '📄',
    permission: 'ver_recetas_emitir',
    allowAdmin: false
  },
  {
    id: 'conversaciones',
    keys: ['F10'],
    label: 'Conversaciones',
    description: 'Bandeja de chats y mensajes',
    path: '/conversaciones',
    icon: '💬',
    permission: 'ver_conversaciones',
    allowAdmin: true
  },
  {
    id: 'contactos',
    keys: ['F11'],
    label: 'Contactos',
    description: 'Asociación de clientes',
    path: '/asociacion-clientes',
    icon: '👥',
    permission: 'ver_contactos',
    allowAdmin: false
  }
];

export function isTypingInFormField(target) {
  if (!target || typeof target !== 'object') return false;
  const el = target;
  const tag = String(el.tagName || '').toLowerCase();
  if (tag === 'input' || tag === 'textarea' || tag === 'select') return true;
  if (el.isContentEditable) return true;
  return Boolean(el.closest?.('[contenteditable="true"]'));
}

export function canUseCrmNavShortcut(user, shortcut) {
  if (!user || !shortcut) return false;
  if (shortcut.adminOnly && !user.isAdmin) return false;
  if (!shortcut.permission) return true;
  const perms = Array.isArray(user.permissions) ? user.permissions : [];
  return perms.includes(shortcut.permission);
}

export function formatShortcutKeys(keys) {
  return (keys || []).join(' · ');
}
